export default __webpack_public_path__ + "static/media/bateria5tom.fcb31821.png";